/*


 */

import 'babel-polyfill';
import $ from 'jquery';
import picturefill from 'picturefill';
import CurrentNav from './CurrentNav';
import MovieController from './MovieController';
import IntersectionManager from './effects/intersection/IntersectionManager';
import IntersectionObject from './effects/intersection/IntersectionObject';


class App {

    constructor() {
        const imagesLoaded = require('imagesloaded');
        imagesLoaded.makeJQueryPlugin($);

        this.isDebug = false; //debug
        this.typoAnime = 2;
        this.pagetopPointY = 1600;
        this.limit = 24;//24時間でリセット
        this.skipIntro = false; //introskip

        if(DIR_ID == 'mainichicare') {
            //local storage
            //localstorageからチェック済み管理データ取得
            this.gumdata = JSON.parse(localStorage.getItem('gumdata'));
            //初回アクセス等、チェックフラグがない場合
            if (!this.gumdata) {
                let d = new Date();
                this.gumdata = { visited: true, time: d.getTime() };
                localStorage.setItem('gumdata', JSON.stringify(this.gumdata));
            } else {
                //チェックフラグがある場合経過時間をチェック
                let oldTime = this.gumdata.time;
                let d = new Date()
                let newTime = d.getTime();
                let limit = this.limit //minutes
                if ((newTime - oldTime) > limit * 60 * 60 * 1000) {
                    //リセット
                    localStorage.removeItem('gumdata');
                    let d = new Date();
                    this.gumdata = { val: [], time: d.getTime() };
                } else {
                    //非リセット
                    this.skipIntro = true;
                }
            }
        }

        this.doPreload();
        this.setScroll();
        this.initSmoothScroll();
        this.sH = $(window).height();

        picturefill();

        $(window).on("resize",(e)=>this.handleResize(e));
        this.handleResize();

        if(DIR_ID != 'mainichicare') {

            //カレントナビゲーション
            let _sections = [];
            $('.glb-pageWrapper').children().each(function(i, el){
                if(i > 0) _sections.push($(el));
            });
            _sections.push($("#anc-footer"));
            this.currentNav = new CurrentNav($("#prg-gnav li"), _sections);

            this.setIntersectionObserver();

        }

        if(DIR_ID == 'ketsuatsutakame') {
            // CMギャラリー
            this.movieController = new MovieController();
        }

    }

    finishIntro(){


    }

    doPreload(){
        this.$bar = $("#prg-preload-bar");
        let countImages = $('.glb-pageWrapper img').length;
        let loadedCount = 0;
        let _this = this;
        $('.glb-pageWrapper').imagesLoaded({ background: '.preload-bg' })
        .always(function (instance) {
            _this.$bar.css({
                "transition-duration":".5s",
                "transform": "scale3d(1,1,1)"
            })
            setTimeout(()=>{
                $("#prg-preloader").addClass("is-hidden");

                if(DIR_ID == 'mainichicare') {
                    if(_this.skipIntro){
                        _this.intro2();
                    } else {
                        _this.intro();
                    }
                } else {
                    _this.intro2();
                }


            },600)

        })
        .done(function (instance) {
        })
        .fail(function () {
        })
        .progress(function (instance, image) {
            if (image.isLoaded) {
                loadedCount += 1;

                //var countLoadedImages = $('#gallery img.loaded').length;

                let per = (loadedCount / countImages) * 0.6;
                _this.$bar.css({
                    "transform": "scale3d(" + per + ",1,1)"
                })
            }
        });
    }

    intro(){

        //$("#prg-intro-ci").addClass("is-active");

        let textCount = 0;
        let numText = $("#prg-intro-list li").length;
        let delay = (this.isDebug) ? 100 : 650;

        $("#prg-intro-list li").eq(0).addClass("is-active");
        setTimeout(()=>{
            $("#prg-intro-list li").eq(1).addClass("is-active");
            $("#prg-intro-list li").eq(2).addClass("is-active");
        },200)
        setTimeout(() => {
            $("#prg-intro-list li").eq(3).addClass("is-active");
            $("#prg-intro-list li").eq(4).addClass("is-active");
        }, 400)
        setTimeout(() => {
            $("#prg-intro-list li").eq(5).addClass("is-active");
            $("#prg-intro-list li").eq(6).addClass("is-active");
            $("#prg-intro-list li").eq(7).addClass("is-active");
        }, 600)


        $("#prg-intro-arrow").addClass("is-active")
        $("#prg-intro-container").on("click", () => {
            this.intro2()
        });
    }

    intro2(){
        let numText = $("#prg-intro-list li").length;
        $("#prg-intro-arrow").addClass("is-leave");
        $("#prg-intro-list li").each(function(index){
            (function($dom,ind){
                setTimeout(()=>{
                    $dom.addClass("is-leave");
                },(numText - ind) * 50)
            })($(this),index)
        })
        setTimeout(()=>{
            $('.glb-pageWrapper').addClass("is-active");
            $('#prg-intro').addClass("is-leave");
        },800)

        if(DIR_ID == 'stresskeigen') {

            setTimeout(()=>{
                $(".pg-top-right").removeClass("is-intro");
                $(".pg-top-left").removeClass("is-intro");
            },1400);

            setTimeout(()=>{
                $(".pg-top__title").removeClass("is-intro");
                this.showTitle()
            },2400);

            setTimeout(()=>{
                $(".pg-top-right__01").removeClass("is-intro");
                $(".pg-top-right__02").removeClass("is-intro");
                $(".pg-top-right__03").removeClass("is-intro");
                $(".pg-top-right__04").removeClass("is-intro");
                $(".pg-top-right-notice__heading").removeClass("is-intro");
                $(".pg-top-right-notice__text").removeClass("is-intro");
                $(".pg-top__scroll").removeClass("is-intro");
                this.finishIntro();
            },3700);

        } else if (DIR_ID == 'ketsuatsutakame') {

            setTimeout(()=>{
                $(".pg-top-mv").removeClass("is-intro");
            },1400);

            setTimeout(()=>{
                $(".pg-top-right").removeClass("is-intro");
                $(".pg-top-left").removeClass("is-intro");
            },2000);

            setTimeout(()=>{
                this.showTitle()
            },2400);

            setTimeout(()=>{
                $(".pg-top__scroll").removeClass("is-intro");
                this.finishIntro();
            },3400);

        }

    }

    showTitle(){

        if(DIR_ID == 'stresskeigen') {

            let del = 500;
            $(".pg-top__title__pict.of-01").removeClass("is-hidden");

            setTimeout(()=>{
                $(".pg-top__title__pict.of-01").addClass("is-hidden");
                $(".pg-top__title__pict.of-02").removeClass("is-hidden");
                this.animateTypo($(".prg-typo1"));

            }, del * 1)
            setTimeout(() => {
                $(".pg-top__title__pict.of-02").addClass("is-hidden");
                $(".pg-top__title__pict.of-03").removeClass("is-hidden");
                this.animateTypo($(".prg-typo2"));

            }, del * 2)
            setTimeout(() => {
                $(".pg-top__title__pict.of-03").addClass("is-hidden");
                $(".pg-top__title__pict.of-04").removeClass("is-hidden");
                this.animateTypo($(".prg-typo3"));
                $(".pg-top__title__balloon").removeClass("is-intro");
                $("#prg-gnav").removeClass("is-intro");
                /*TweenMax.to($("#prg-gnav"),1,{
                    alpha: 1
                })*/
            }, del * 3)

        } else if (DIR_ID == 'ketsuatsutakame') {

            let delPict = 300, delTypo = 500;

            // Pict Animation
            $(".pg-top__title__pict.of-01").removeClass("is-hidden");

            setTimeout(()=>{
                $(".pg-top__title__pict.of-01").addClass("is-hidden");
                $(".pg-top__title__pict.of-02").removeClass("is-hidden");
            }, delPict * 1)
            setTimeout(() => {
                $(".pg-top__title__pict.of-02").addClass("is-hidden");
                $(".pg-top__title__pict.of-03").removeClass("is-hidden");
            }, delPict * 2)
            setTimeout(() => {
                $(".pg-top__title__pict.of-03").addClass("is-hidden");
                $(".pg-top__title__pict.of-04").removeClass("is-hidden");
            }, delPict * 3)
            setTimeout(() => {
                $(".pg-top__title__pict.of-04").addClass("is-hidden");
                $(".pg-top__title__pict.of-05").removeClass("is-hidden");
            }, delPict * 4)
            setTimeout(() => {
                $(".pg-top__title__pict.of-05").addClass("is-hidden");
                $(".pg-top__title__pict.of-06").removeClass("is-hidden");
            }, delPict * 5)

            // Typo Animation
            setTimeout(()=>{
                this.animateTypo($(".prg-typo1"));
            }, delTypo * 1)
            setTimeout(() => {
                this.animateTypo($(".prg-typo2"));
            }, delTypo * 2)
            setTimeout(() => {
                this.animateTypo($(".prg-typo3"));
                $(".pg-top__title__balloon").removeClass("is-intro");
                $("#prg-gnav").removeClass("is-intro");
            }, delTypo * 3)

        }

    }

    animateTypo($container){
        let _this = this;
        $container.each(function (n) {
            if(_this.typoAnime==1){
                TweenMax.fromTo($(this), 1, {
                    scale: 0,
                    alpha: 1,
                    rotation: -20,
                    transformOrigin: "50% 50%"
                }, {
                    scale: 1,
                    rotation: 0,
                    ease: Elastic.easeOut
                })
            } else {
                $(this).css({"opacity":1});
            }


        })
    }

    /**
     * スクロールイベント
     */
    setScroll(){
        //$(window).on("scroll",()=>{this.handleScroll()})
        this.$pagetop = $("#prg-pagetop");
        setInterval(()=>{
            this.handleScroll();
        },300)
    }
    handleScroll(){
        let st = $(window).scrollTop();
        if(st > (this.pagetopPointY - this.sH)){
            this.$pagetop.addClass("is-active");
        } else {
            this.$pagetop.removeClass("is-active");
        }
    }

    /*
    * スムーススクロール
    */
    initSmoothScroll() {
        $('a[href^="#"]').not(".no-scroll").on("click", (_t) => {
            var speed = 600;

            var href = $(_t.currentTarget).attr("href");

            //クリックターゲットにhref要素が見つからない場合、親に遡って探す
            var parent = $(_t.target);
            var n = 0;
            while (href == undefined) {
                parent = parent.parent();
                href = parent.attr("href");
                n++;
                if (n > 10) {
                    break;
                }
            }
            var target = $(href);
            if (href == "#") {
                target = $("body");
            }
            let offset = $(_t.currentTarget).data("offset");
            offset = (!offset) ? 0 : offset
            this.smoothScrollTo(target, speed, offset);
            return false;
        })
    }

    smoothScrollTo(target, speed, offset) {

        if (!offset) {
            offset = 0
        }

        var position = target.offset().top + offset;
        $('body,html').animate({ scrollTop: position }, speed);
    }

    handleResize(){
        this.sH = $(window).innerHeight();
        $(".glb-header-menu").css({ "height": innerHeight });
    }

    handleTouchmove(event){

        if(this.sclock){
            event.preventDefault();
        }

    }

    setIntersectionObserver() {

        let _this = this;
        /**
         * observe ef-scroll
         */
        const mutationObserver = new MutationObserver(function (records) {
            records.forEach(function (record) {
                var oldVal = record.oldValue;
                var newVal = record.target.className;
                if (oldVal.indexOf("ef-scroll") > 0 && newVal.indexOf("ef-scroll<0")) {
                    _this[$(record.target).data("func")]();
                }

            })
        })
        var options = {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ["class"]
        }
        $(".prg-hook").each(function () {
            mutationObserver.observe($(this)[0], options);
        })


        //intersection observer
        let opt = {
            selector: '.ef-scroll',
            rootMargin: "-10% 0px"
        };
        let ioManager = new IntersectionManager(opt);
        for (let i = 0; i < $(".ef-scroll").length; i++) {
            (function (i) {
                let $d = $(".ef-scroll").eq(i);

                let io = new IntersectionObject($d, null);
                ioManager.addObject(io);
            })(i)
        }
        ioManager.startIntersection();
    }

}



const _app = new App();



// WEBPACK FOOTER //
// ./src/scripts/app.js